import axios from 'axios'

class SurveyService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
   * @author Isaac Martinez
   * @description  Get surveys by clientId
   * @date 11-06-2024
   * @param {String} token
   * @return {Object} 
   * @memberof SurveyService
   */
  async getSurveys(token) {
    let response = await axios.get(`${this.apiUrl}/surveys`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    return response.data.data
  }

  /**
   * @author Brayan Salas
   * @description Method to create a new survey
   * @param {*} data
   * @param {*} token
   * @return {*} 
   * @memberof OfferService
   */
  async createSurvey(data, token) {
    let response = await axios.post(`${this.apiUrl}/survey`, data, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
   * @author Brayan Salas
   * @description  Get survey by id
   * @date 15-07-2024
   * @param {String} surveyId
   * @param {String} token
   * @return {Object} 
   * @memberof SurveyService
   */
  async getSurveyDetailsById(surveyId, token) {
    let response = await axios.get(`${this.apiUrl}/survey-details?surveyId=${surveyId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    return response.data.data
  }

  /**
   * @author Brayan Salas
   * @description Delete a survey
   * @date 17-07-2024
   * @param {String} surveyId
   * @param {String} token
   * @return {Object}
   * @memberof SurveyService
   */
  async deleteSurvey(surveyId, token) {
    let response = await axios.delete(`${this.apiUrl}/survey?surveyId=${surveyId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      })
    return response.data.data
  }

  /**
 * @author Adriana Fernandez
 * @description  Get survey answers
 * @date 07-11-2024
 * @param {String} surveyId
 * @param {String} token
 * @return {Object} 
 * @memberof SurveyService
 */
  async getSurveyAnswers(surveyId, token) {
    let response = await axios.get(`${this.apiUrl}/survey-answers/${surveyId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }
  /**
 * @author Adriana Fernandez
 * @description  Download survey answers
 * @date 11-11-2024
 * @param {String} surveyId
 * @param {String} token
 * @return {Object} 
 * @memberof SurveyService
 */
  async downloadSurveyAnswers(surveyId, token) {
    const response = await axios.get(`${this.apiUrl}/survey-answers/${surveyId}/download`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    if (response.data.statusCode !== 200) {
      throw new Error(response.data.message)
    }
    return response.data.data
  }
}
export { SurveyService as default }